/* istanbul ignore file */
export const MAXIMUM_DROPDOWN_ITEMS = 7;
export const CENTER_OF_GERMANY = { lat: 51.163361, lng: 10.447683 };

export const DEFAULT_VERIFY_MAIL_RESEND_WAITING_TIME = 60; // seconds

export const IMGLY_TEMPLATES_FOLDER = 'ad7d45e0-98cc-4a79-944e-b0bf669bfc71';
export const IMGLY_TEMPLATES_PREVIEW_FOLDER =
  'e7b7b601-4d1c-427c-a388-c1ab09fef5f8';
export const CREATIVE_BUILDER_ASSETS_FOLDER =
  '92f86ee8-acac-4acb-8724-dc71bce3587b';
export const CREATIVE_BUILDER_FOLDER = 'ecb539da-c390-48f0-9d8c-326709b0b609';

export const JOBS_FOLDER = '89486b97-c24a-4cf9-94b4-2f869222f50c';
export const JOB_CREATIVES_FOLDER = '3ff20853-43a4-43a4-ae01-cae9175486d2';
export const JOB_STOCK_IMAGES_FOLDER = '200235ec-2f9c-42e0-984b-c3e4460ef8d4';
export const JOB_CREATIVE_SCENES_FOLDER =
  '162df3b6-7a90-4479-8794-95e0cb817f13';

export const CHATBOT_PATH = '/chatbot/:jobId';

export const EMPLOYER_BRANDS_FOLDER = 'fe83d80d-5d2b-481a-a676-c40452e480f3';

export const MAX_NUMBER_OF_FAVORITE_STOCK_IMAGES = 4; // max number of favorite creatives per job allowed
